<div class="main-container-edit">
    <div class="view-component-title">{{'translate.title.ai'|translateTA}}</div>
    <div class="form-container-main">
        <form [formGroup]="formGroup" class="form-container">
            <div class="tem-field">
                <span class="tem-field-label">{{'translateform.origem'|translateTA}}</span>
                <nz-select formControlName="origem" [nzPlaceHolder]="'translateform.origem'|translateTA">
                    <nz-option *ngFor="let item of languages" [nzValue]="item.col" [nzLabel]="item.name"></nz-option>
                </nz-select>
            </div>
            <div class="tem-field">
                <span class="tem-field-label">{{'translate.ia.destino'|translateTA}} <span class="tem-field-required">*</span></span>
                <nz-select formControlName="destino" nzShowSearch nzAllowClear
                    [nzPlaceHolder]="'translate.ia.destino'|translateTA">
                    <nz-option *ngFor="let item of languages|arrayFilter:'col':'PTBR':true:true" [nzValue]="item.col" [nzLabel]="item.name"></nz-option>
                </nz-select>
            </div>
        </form>
    </div>
    <nz-divider class="section-divider"></nz-divider>
    <div class="toolbar-action">
        <div class="spacer"></div>
        <button type="button" nz-button nzType="primary" nzShape="circle" [disabled]="!canDelete"
            (click)="translateItens()" nz-tooltip [nzTooltipTitle]="'actions.ia'|translateTA">
            <span nz-icon nzType="robot"></span>
        </button>
    </div>
    <div class="list-ai-select">
        <div class="ai-empty" *ngIf="arrayList.length === 0">{{'simpledatagrid.norows'|translateTA}}</div>
        <div class="ai-row" *ngFor="let item of arrayList; let idx = index"
            [ngClass]="{'odd': idx % 2 !== 0, 'even': idx % 2 === 0}">

            <div class="item-ai">

                <div class="item-ai-info">
                    <span>{{item[origemCol]}}</span>-<span>({{getCountIds(item.guid)}})</span>
                </div>

                <div class="full-width" *ngIf="destinoCol!=null && destinoCol!=''">
                    <input nz-input nzSize="small" [(ngModel)]="item[destinoCol]"
                        (click)="$event.stopPropagation()" (ngModelChange)="changingTranslation(item)"/>
                </div>

                <span nz-icon nzType="delete" class="cancel action-icon"
                    nz-tooltip [nzTooltipTitle]="'actions.delete'|translateTA"
                    (click)="removeFile(item.guid)"
                    *ngIf="(item[destinoCol]==''||item[destinoCol]==null) && canDelete"></span>

                <span nz-icon nzType="clock-circle" class="waiting"
                    *ngIf="(item[destinoCol]==''||item[destinoCol]==null) && !canDelete"></span>

                <nz-spin nzSimple nzSize="small" class="process"
                    *ngIf="item.translating==true"></nz-spin>

                <span nz-icon nzType="warning" class="error" nz-tooltip [nzTooltipTitle]="item.error"
                    *ngIf="(item.error!=null)"></span>

                <span nz-icon nzType="check-circle" class="done"
                    *ngIf="item.translating == false && item[destinoCol]!=null && item[destinoCol]!='' && (item.error==null)"></span>

            </div>
        </div>
    </div>
    <actions-buttons [buttonList]="buttonList"></actions-buttons>
</div>
